import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CreditosService } from '../../../services/service.index';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-creaperiodopago',
  templateUrl: './creaperiodopago.component.html',
  styles: []
})
export class CreaPeriodoPagoComponent implements OnInit {

  forma: FormGroup;
  ido: string;
  service: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private creditosService: CreditosService,
    public router: Router
  ) { }


  ngOnInit() {
    this.forma = new FormGroup({
      Key: new FormControl( null , Validators.required ),
      Descripcion: new FormControl( null , Validators.required )

    } );
  }


  CreaCondicion() {

    // Obtener el elemento por el id
    const Key: any = document.getElementById('Key');
    const Descripcion: any = document.getElementById('Descripcion');
    const Valor: any = document.getElementById('Valor');
    const Tpp: any = document.getElementById('Tpp');
    // Obtener el valor de la opción seleccionada

    const valorKey = Key.value;
    const valorDescripcion = Descripcion.value;
    const valorValor = Valor.value;
    const valorTpp = Tpp.value;

    const params = {
      key: valorKey,
      description: valorDescripcion,
      value: valorValor,
      pp_type: valorTpp,
      secret_key: '',
      token: ''
    }

    this.creditosService.crearPeriodoPago( params ).subscribe( () => {
    Swal.fire({
      title: 'Creacion de periodo pag exitosa',
      text: '',
      icon: 'success',
      showConfirmButton: true,
      showCancelButton: false,
      allowOutsideClick: false
    }). then ( res => {
      if ( res.value ) {
        this.router.navigate(['/panelcontrol/periodospago']);
      }

    } );

  }, (err) => {            // console.clear();
    // console.log(err);
                            Swal.fire(
                              'Ocurrio un error',
                              'Error',
                              'error'
                           );
                        } );

  }


}
